import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Auth APIs
export const authAPI = {
  createSession: (sessionId) => api.post('/auth/session', { session_id: sessionId }),
  getMe: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
  deleteAccount: () => api.delete('/auth/account'),
  exportData: () => api.get('/auth/export-data')
};

// Campaign APIs
export const campaignAPI = {
  create: (data) => api.post('/campaigns', data),
  getAll: () => api.get('/campaigns'),
  getOne: (id) => api.get(`/campaigns/${id}`),
  update: (id, data) => api.put(`/campaigns/${id}`, data),
  delete: (id) => api.delete(`/campaigns/${id}`),
  duplicate: (id) => api.post(`/campaigns/${id}/duplicate`)
};

// Generation API
export const generateAPI = {
  generate: (data) => api.post('/generate', data)
};

// Feedback API
export const feedbackAPI = {
  submit: (campaignId, feedback) => api.post('/feedback', { campaign_id: campaignId, feedback })
};

// Credits APIs (Razorpay)
export const creditsAPI = {
  get: () => api.get('/credits'),
  getPlans: () => api.get('/credits/plans'),
  createOrder: (plan) => api.post('/credits/create-order', { plan }),
  verifyPayment: (data) => api.post('/credits/verify-payment', data),
  history: () => api.get('/credits/history')
};

// Affiliate APIs
export const affiliateAPI = {
  getDashboard: () => api.get('/affiliate/dashboard'),
  applyReferral: (referralCode) => api.post('/affiliate/apply-referral', { referral_code: referralCode }),
  requestPayout: (paymentMethod, paymentDetails) => api.post('/affiliate/request-payout', { 
    payment_method: paymentMethod, 
    payment_details: paymentDetails 
  }),
  getPayouts: () => api.get('/affiliate/payouts')
};

// Constants API
export const constantsAPI = {
  get: () => api.get('/constants')
};

export default api;
